/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');

var MomentCell = require('common/backgrid/MomentCell');

var tmplNonDepEntityDBAHistoryView = require('../templates/NonDepEntityDBAHistoryView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepEntityDBAHistoryView,

  className: 'non-dep-entity-dba-history-view container-fluid',

  ui: {
    entityDBAHistory: '.entity-dba-history-container'
  },

  regions: {
    entityDBAHistory: '@ui.entityDBAHistory'
  },

  onBeforeShow: function() {
    this.entityDBAHistory = new GridView({
      columns: [
        {
          name: 'modifiedDate',
          label: 'Changed Date',
          cell: MomentCell.MomentCell,
          formatter: MomentCell.MomentDateTimeFormatter.extend({
            emptyValue: '--'
          }),
          sortValue: MomentCell.MomentSortValue,
          headerCell: 'custom',
          width: 33,
          editable: false
        },
        {
          name: 'modifiedBy',
          label: 'Changed By',
          cell: 'string',
          headerCell: 'custom',
          width: 33,
          editable: false
        },
        {
          name: 'dba',
          label: 'DBA',
          cell: 'string',
          headerCell: 'custom',
          width: 34,
          editable: false
        }
      ],
      emptyText: 'No DBA History',
      collection: new PageableCollection(this.model.get('dbaHistory'), { pageSize: 25 })
    });

    this.showChildView('entityDBAHistory', this.entityDBAHistory);
  }
});
